import { Component, signal, OnInit } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { AuthService } from 'src/auth/services/auth.service';
import { FormEvents } from 'src/shared/constants';
import { CodeTablesClient, PersonAddressDto, ProfileClient, StateDto } from 'src/shared/services/api.service';

@Component({
  standalone: false,
  selector: 'edportal-educator-contact-address',
  templateUrl: './educator-contact-address.component.html',
  styles: ``,
})
export class EducatorContactAddressComponent implements OnInit {
  addAddressMode = signal(false);
  selectedAddress = signal<PersonAddressDto | undefined>(undefined);
  states$!: Observable<StateDto[]>;
  dataLoaded = signal(false);
  address = signal<PersonAddressDto | undefined>(undefined);
  states = signal<StateDto[]>([]);

  constructor(
    private readonly codeTablesClient: CodeTablesClient,
    private readonly profileClient: ProfileClient,
    public authService: AuthService,
  ) {}

  ngOnInit() {
    this.loadAddress();
    this.codeTablesClient.getStates().subscribe((x) => this.states.set(x));
  }

  loadAddress() {
    this.profileClient
      .getPersonsAddressInfo()
      .pipe(finalize(() => this.dataLoaded.set(true)))
      .subscribe((x) => this.address.set(x));
  }

  enableAddAddress() {
    this.addAddressMode.set(true);
  }

  handleFormEvent(emissionValue: FormEvents) {
    if (emissionValue == FormEvents.Cancelled) {
      this.addAddressMode.set(false);
    } else if (emissionValue == FormEvents.Successful) {
      this.addAddressMode.set(false);
      this.loadAddress();
    }
  }

  loadEditForm() {
    this.selectedAddress.set(this.address());
    this.addAddressMode.set(true);
  }
}
